// PhoneInput component for booking contact form
import React from 'react';
import { Phone } from 'lucide-react';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange }) => {
  return (
    <div className="relative">
      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#2A382A]/40" />
      <input
        type="tel"
        id="phone"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-12 pr-4 py-3 bg-[#F2F3F4] border border-[#2A382A]/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E85C0D] text-[#2A382A]"
        placeholder="+1 (555) 123-4567"
        required
      />
    </div>
  );
};

export default PhoneInput;